module.exports = __webpack_public_path__ + "static/media/Partly_Rainfall_Stormy_Busy.e55adb78.gif";